export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrap" */'./ThemeImporter'),
  },
};
